"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.combineParallelCalls = exports.getDeferred = exports.doWhile = exports.delay = void 0;
const delay = (ms, options = {}) => new Promise((resolve) => {
    const timer = setTimeout(resolve, ms);
    if (options.unref && timer.unref) {
        timer.unref();
    }
});
exports.delay = delay;
async function doWhile(doFn, whileFn) {
    do {
        await doFn();
    } while (await whileFn());
}
exports.doWhile = doWhile;
function getDeferred() {
    let resolve = undefined;
    let reject = undefined;
    let promise = new Promise((resolveCb, rejectCb) => {
        resolve = resolveCb;
        reject = rejectCb;
    });
    // TS thinks we're using these before they're assigned, which is why
    // we need the undefined types, and the any here.
    return { resolve, reject, promise };
}
exports.getDeferred = getDeferred;
/**
 * Wrap a function, so that any parallel calls which happen while the async function
 * is pending return the same value as the first call (so the function is only run
 * once, but the result is shared). This is useful for expensive async functions or
 * race conditions. This ignores arguments completely, and is only applicable for
 * functions that don't need any other input.
 */
function combineParallelCalls(fn) {
    let pendingPromise;
    return () => {
        if (pendingPromise === undefined) {
            pendingPromise = fn().finally(() => {
                pendingPromise = undefined;
            });
        }
        return pendingPromise;
    };
}
exports.combineParallelCalls = combineParallelCalls;
//# sourceMappingURL=promises.js.map